var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.60742C12.5 3.74549 12.3881 3.85742 12.25 3.85742H7.75C7.61193 3.85742 7.5 3.74549 7.5 3.60742V2.54492C7.5 2.40685 7.61193 2.29492 7.75 2.29492H12.25C12.3881 2.29492 12.5 2.40685 12.5 2.54492V3.60742ZM4.21875 6.41998H2.75C2.61193 6.41998 2.5 6.30805 2.5 6.16998V5.10748C2.5 4.96941 2.61193 4.85748 2.75 4.85748H17.25C17.3881 4.85748 17.5 4.96941 17.5 5.10748V6.16998C17.5 6.30805 17.3881 6.41998 17.25 6.41998H15.7812V17.0801C15.7812 17.4253 15.5014 17.7051 15.1562 17.7051H4.84375C4.49857 17.7051 4.21875 17.4253 4.21875 17.0801V6.41998ZM5.78125 6.41998V16.1426H14.2188V6.41998H5.78125ZM8.96875 8.88885C9.10682 8.88885 9.21875 9.00078 9.21875 9.13885V13.6389C9.21875 13.7769 9.10682 13.8889 8.96875 13.8889H7.90625C7.76818 13.8889 7.65625 13.7769 7.65625 13.6389V9.13885C7.65625 9.00078 7.76818 8.88885 7.90625 8.88885H8.96875ZM12.0938 13.8889C12.2318 13.8889 12.3438 13.7769 12.3438 13.6389V9.13885C12.3438 9.00078 12.2318 8.88885 12.0938 8.88885H11.0312C10.8932 8.88885 10.7812 9.00078 10.7812 9.13885V13.6389C10.7812 13.7769 10.8932 13.8889 11.0312 13.8889H12.0938Z",
    fill: "#070A26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.aca7689f96b9c7805e32db18d2224833.svg";
export { ForwardRef as ReactComponent };